module.exports = __webpack_public_path__ + "img/background.bb35b12c.jpg";